import { apiConfig } from "../../authConfig";
import { apiErrorFromResponse } from "../../utils/apiError";

/**
 * One request path for the Internal Audit tabs. Resolves to `json.data`; any non-2xx or `success:false`
 * becomes an ApiError whose message is safe to show (4xx keeps the server's sentence, a bare 5xx never leaks
 * raw text). Callers turn a thrown value into text with `userMessageForError`.
 */
export async function iaRequest(getApiToken, path, { method = "GET", body } = {}) {
  const token = await getApiToken();
  const headers = { Authorization: `Bearer ${token}` };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const res = await fetch(`${apiConfig.baseUrl}${path}`, {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || !json?.success) throw apiErrorFromResponse(res, json);
  return json.data;
}
